import { Point } from './point';

export class Line {
  constructor(readonly p0: Point, readonly p1: Point) {}
}

export function hLineByMidpoint(m: Point, d: number): Line {
  const p0 = new Point(m.x-d, m.y)
  const p1 = new Point(m.x+d, m.y)
  return new Line(p0, p1)
}

export function vLineByMidpoint(m: Point, d: number): Line {
  const p0 = new Point(m.x, m.y-d)
  const p1 = new Point(m.x, m.y+d)
  return new Line(p0, p1)
}